<template>
  <v-col
    class="pa-0"
  >
    <v-container
      v-if="isReadingReport"
      class="ma-0"
      fluid
    >
      <v-row v-if="haveSelectedSearch">
        <v-col>
          <report-bar :favorites="favorites" />
          <metric-bar :metrics="metrics" />

          <data-table
            ref="table"
            :actions="actions"
            :data-groups="currentDataTableGroups"
          />
        </v-col>
      </v-row>
    </v-container>

    <report-manager v-else />
  </v-col>
</template>

<script>
import mixin from 'src/utils/mixin'

export default {
  name: 'ProjectProfile',
  components: {
    DataTable: () => import('src/tools/components/table/DataTable'),
    MetricBar: () => import('src/dashboard/components/MetricBar'),
    ReportBar: () => import('src/dashboard/components/ReportBar'),
    ReportManager: () => import('src/report/components/ReportManager'),
  },
  mixins: [mixin],
  data() {
    return {
      actions: [],
      slideMetrics: [],
    }
  },
  computed: {
    project: (state) => state.project,
  },
}
</script>
